
module.exports = {
    "global.project.center": "Project Center",
    "nav.samples": "Samples",
    "nav.tutorial": "Tutorial",
    "common.confirm": "Confirm",
    "common.cancel": "Cancel",
    "common.remove": "Remove",
    "common.operation": "Operation",
    "common.tip": "Tip",
    "common.role": "Role",
    "common.creator": "Creator",
    "common.project": "Project",
    "common.creation.time": "Creation Time",
    "common.developer": "Developer",
    "home.no.project.click": "Project list is empty, please click",
    "home.add.project": "Add Project",
    "home.add.first.project": "Add My First Project",
    "home.confirm.remove.user": "Confirm removing user ?",
    "home.project.name": "Poject Name",
    "home.project.description": "Poject Description",
    "home.add.user": "Add User",
    "home.username": "Username",
    "home.project.detail": "Project Detail",
    "home.release.management": "Release Management",
    "home.development.authorization": "Development Authorization",
    "home.enter.workbench": "Enter workbench",
    "home.my.role": "My Role",
    "home.developer.list": "Developer List",
    "home.add.member": "Add Member",
    "home.project.public": "Public",
    "tip.input.project.name": "Please input project name",
    "tip.project.name.length": "The project name should be {{min}}-{{max}} characters",
    "tip.project.description.length": "The project description cannot exceed {{max}} characters",
    "tip.input.username": "Please input username",
    "tip.select.role": "Please select a role",
    "tip.no.results": "No results found",
    "delete": "Delete",
    "home.confirm.remove.project": "Are you sure to delete this project?",
    "myProject": "My Project",
    "deletedProject": "Deleted Project",
    "cloneProject": 'Clone Project',
    "grant": "Grant",
    "cloneInfo": "Clone Info",
    "clonedFrom": "Cloned From",
    "number": "Number",
    "removePermanent": "Are you sure to delete {{name}} permanently ?",
    "startWithTest": "The project name can't start with test",
    "leave": "leave project",
    "tip.exit": "Are you sure to leave this project ?",
    "public.project": "Public",
    "unpublic.project": "Private",
    "home.confirm.unpublic.project": "Are you sure to make project public ?",
    "home.confirm.public.project": "Are you sure to make project private ?",
    "home.sure": "Sure",
    "home.clone.tip": "Note: You need to open all pages in cloned project's workbench to confirm each page fees, otherwise the project can't be published.",
    "wait.project.clone": "Cloning project, please wait...",
    "pri.detail": "Privilege Detail",
    "view.info": "View Project Info",
    "del.project": "Delete Project",
    "release.project": "Release Project",
    "release.project.dev": "Release Trial",
    "add.project.user": "Add Project Member",
    "change.role": "Change Member Role",
    "del.member": "Remove Member",
    "view.workbench": "View Workbench",
    "edit.workbench": "Edit Workbench",
    "pri.note": "Note: everyone can view workbench in public project, but cannot edit workbench",
    "transferProject": "Transfer",
    "home.tranfser.user": "Transfer Project",
    "home.no.pub": "You are not allowed to publish project",
    "edit": "Edit",
    "folder.name.too.long": "The length of name should not be great than {{max}}",
    "remove.folder.tip": "Please move  the project out",
    "add.folder": "Add Folder"
}


// WEBPACK FOOTER //
// ./src/i18n/locale.en.js